module.exports = {
  app_url: process.env.REACT_APP_APP_URL ?? "",
  product: "sidekick",
  api_url: process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : "http://localhost",
  api_version: 6,
  customer: process.env.REACT_APP_CUSTOMER,
  sentry_env: process.env.REACT_APP_SENTRY_ENV,
  sentry_dsn: process.env.REACT_APP_SENTRY_DSN,
  privacy_policy_url: "https://cosoft.co.uk/connect-privacy-policy/",
  docs_url: "https://docs.connect.cosoft.co.uk",
  tenor_api_key: process.env.REACT_APP_TENOR,
  // Each desktop release also uploads Sidekick-latest-{arm64,x64}.dmg here
  mac_download_base:
    "https://storage.googleapis.com/sidekick-desktop-releases/mac/stable",
  // The call dashboard needs an API endpoint that isn't live yet
  dashboard_enabled: process.env.REACT_APP_DASHBOARD_ENABLED === "true",
};
